import { render, staticRenderFns } from "./ErrorLayout.vue?vue&type=template&id=9e79d940&scoped=true&"
import script from "./ErrorLayout.vue?vue&type=script&lang=ts&"
export * from "./ErrorLayout.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorLayout.vue?vue&type=style&index=0&id=9e79d940&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e79d940",
  null
  
)

export default component.exports